// Lowercased, exact-match hosts (no subdomains except netlify wildcard)
const SPECIAL_HOSTS = new Set([
	'uk.emma-live.com',
	'uk2.emma-live.com',
	'us.emma-live.com',
	'us2.emma-live.com',
	'dev2.emma-live.com',
	'astarauction.com',
	'blacktieauctions.org',
	'weareeventpal.com',
	'echelonfundraising.com',
	'staging.uk2.emma-live.com',
])

export const buildEmmaDomainReferer = (href = window.location.href) => {
	// Fallback if window/location is weird
	if (!href) return ''

	const url = new URL(href)
	const hostname = url.hostname.toLowerCase()

	const isNetlify = hostname.endsWith('.netlify.app')
	const isSpecial = isNetlify || SPECIAL_HOSTS.has(hostname)

	// For special hosts (incl. *.netlify.app): send origin + first path segment (if any)
	if (isSpecial) {
		// pathname like "/foo/bar" -> firstSeg = "foo"
		const firstSeg = url.pathname.split('/').filter(Boolean)[0]
		return firstSeg ? `${url.origin}/${firstSeg}` : url.origin
	}

	// For others (custom domains): send only the host (origin)
	return url.origin
}
